import React from 'react'
import { connect } from 'react-redux';
import { PatientHomePeerReviewHeader, PatientHomePeerReviewBody } from 'PatientCareCenter/Home/PeerReviews'
import styles from './PeerReviews.module.css'
import { ScrollDiv } from '_components';

class PatientHomePeerReviews extends React.Component {
    render() {
        if (this.props.reviews && Object.keys(this.props.reviews).length > 0) {
            return (
                <ScrollDiv divId={this.props.ptno + '_PCC_HOME_PEERREVIEWS'} className={styles.peer_review_wrapper}>
                    {Object.keys(this.props.reviews)
                        .map(id => {
                            const review = this.props.reviews[id];
                            return (
                                <span key={review.id} className={styles.review}>
                                    <PatientHomePeerReviewHeader id={review.id} />
                                    <PatientHomePeerReviewBody id={review.id} />
                                </span>
                            )
                        })
                    }

                </ScrollDiv>
            );
        } else {
            return (<i>No Peer Reviews Found</i>);

        }
    }
}

function mapStateToProps(state) {
    return {
        reviews: Object.keys(state.entities.peerReviews)
            .filter(key => { return state.entities.peerReviews[key].ptno === state.ui.patients.selectedPtno })
            .sort((a, b) => new Date(state.entities.peerReviews[b].date).getTime() - new Date(state.entities.peerReviews[a].date).getTime())
            .map(key => state.entities.peerReviews[key]),
        ptno: state.ui.patients.selectedPtno
    };
}

const connectedPatientHomePeerReviews = connect(mapStateToProps)(PatientHomePeerReviews);
export { connectedPatientHomePeerReviews as PatientHomePeerReviews };